import { useEffect } from 'react'
import { noteTakerStore } from 'shared/stores/noteTakerStore'

export function useNoteTakerRecordingLifecycle() {
	useEffect(() => {
		const handleBeforeUnload = () => {
			if (noteTakerStore.shouldShowWidget || noteTakerStore.isStarting) {
				noteTakerStore.forceCleanupRecording()
			}
		}

		window.addEventListener('beforeunload', handleBeforeUnload)

		return () => {
			window.removeEventListener('beforeunload', handleBeforeUnload)
		}
	}, [])
}
